module.exports = __webpack_public_path__ + "static/media/vipps.61c3c3df.png";


//////////////////
// WEBPACK FOOTER
// ./src/Components/Signup/Media/vipps.png
// module id = 42
// module chunks = 0